import {
  Alert,
  Backdrop,
  Box,
  Button,
  ButtonGroup,
  Checkbox,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Drawer,
  FormControl,
  FormControlLabel,
  InputAdornment,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  Snackbar,
  Stack,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
  useMediaQuery,
} from '@mui/material';
// DatePicker imports removed - using custom date inputs for large screens
import {useQuestionnaireApi} from '../api/demographics';

import {
  convertCentimetersToFeetAndInches,
  convertFeetAndInchesToCentimeters,
  convertKilogramsToPounds,
  convertPoundsToKilograms,
} from '../utils/conversions';
import {PrivacyContent} from '../pages/TermsAndPrivacy/privacyContent';
import ConfirmationDialog from './dialogbox/confirmationDialog';
import {TermsOfServiceContent} from '../pages/TermsAndPrivacy/termsOfServiceContent';
import {useEffect, useState} from 'react';
import {useTheme} from '@emotion/react';
import {useLocation, useNavigate} from 'react-router-dom';
import AimdFlowQuestionBase from './aimdFlowQuestionBase';
import dayjs from 'dayjs';
import ScrollableDatePicker from './dateInput/scrollableDatePicker';
import {calculateBMIMetricUnit} from '../utils/calculations';
import {AnimationLoadingScreen} from './loading/loadingScreen';
import {VALIDATION_LIMITS} from '../utils/miscellaneous';
import {medicalConditionsData} from '../data/medicalConditionsData';
import CloseIcon from '@mui/icons-material/Close';
import {drugData} from '../data/drugsData';
import {allergenData} from '../data/allergenData';

//style for measurement TextField
const measurementLabelStyle = {
  '& .MuiInputLabel-root': {
    fontSize: '19px',
    fontWeight: '500',
    textAlign: 'right',
    width: '100%',
    color: '#000000',
  },
};

const CommonErrorMessage = ({text, sx}) => {
  return (
    <Typography
      variant="caption"
      color="error"
      display="flex"
      textAlign="start"
      width="100%"
      gutterBottom
      sx={{
        fontSize: {
          xs: '12px',
          sm: '12px',
          md: '16px',
          lg: '16px',
        },
        padding: '4px 0px 0px 6px', // Padding for the text
        gutterBottom: true, // This adds bottom spacing
        ...sx,
      }}
    >
      {text}
    </Typography>
  );
};

const AimdFlowQuestionsScreen = ({isShowMenuIcon = true, IsShowBackIcon = true, isUserFlow = false}) => {
  const questionnaireApi = useQuestionnaireApi();
  const location = useLocation();
  const theme = useTheme();
  const navigate = useNavigate();
  const isLaptop = useMediaQuery(theme.breakpoints.up('lg'));
  const [isLoading, setIsLoading] = useState(false);
  const [filteredOptions, setFilteredOptions] = useState([]);
  const [openModalPrivacy, setOpenModalPrivacy] = useState(false);
  const [openModalTerms, setOpenModalTerms] = useState(false);
  const [startSubmitData, setStartSubmitData] = useState(false);
  const [ethnicitiesList, setEthnicitiesList] = useState([
    {
      id: 1,
      name: 'American Indian or Alaska Native',
      description:
        'A person having origins in any of the original peoples of North and South America (including Central America), and who maintains tribal affiliation or community attachment.',
    },
    {
      id: 2,
      name: 'Asian',
      description:
        'A person having origins in any of the original peoples of the Far East, Southeast Asia, or the Indian subcontinent including, for example, Cambodia, China, India, Japan, Korea, Malaysia, Pakistan, the Philippine Islands, Thailand, and Vietnam.',
    },
    {
      id: 3,
      name: 'Black or African American',
      description:
        'A person having origins in any of the black racial groups of Africa. Terms such as "Haitian" or "Negro" can be used in addition to "Black or African American."',
    },
    {
      id: 4,
      name: 'Hispanic or Latino',
      description:
        'A person of Cuban, Mexican, Puerto Rican, South or Central American, or other Spanish culture or origin, regardless of race. The term, "Spanish origin," can be used in addition to "Hispanic or Latino."',
    },
    {
      id: 5,
      name: 'Native Hawaiian or Other Pacific Islander',
      description:
        'A person having origins in any of the original peoples of Hawaii, Guam, Samoa, or other Pacific Islands.',
    },
    {
      id: 6,
      name: 'White',
      description:
        'A broad category encompassing people with origins from Europe, the Middle East, North Africa, and some parts of Central and South Asia.',
    },
    {
      id: 7,
      name: 'Mixed',
      description: 'A blend of multiple ethnicities.',
    },
    {
      id: 8,
      name: 'Prefer not to say',
      description: '',
    },
  ]);
  const [genderList, setGenderList] = useState([
    {
      id: 1,
      name: 'Male',
    },
    {
      id: 2,
      name: 'Female',
    },
    {
      id: 3,
      name: 'Intersex',
    },
    {
      id: 4,
      name: 'Prefer not to say',
    },
  ]);

  const [menopauseList, setMenopauseList] = useState([
    {
      id: 1,
      name: 'I have not started menopause (pre-menopausal)',
    },
    {
      id: 2,
      name: 'I am in perimenopause (transition phase with irregular periods and/or symptoms)',
    },
    {
      id: 3,
      name: 'I am in menopause (12 consecutive months without a period, not due to other causes)',
    },
    {
      id: 4,
      name: 'I am post-menopausal (more than 12 months since my last period)',
    },
    {
      id: 5,
      name: 'I am unsure',
    },
  ]);

  const [isDobFirstInteraction, setIsDobFirstInteraction] = useState(true);
  const [currentStep, setCurrentStep] = useState(1);
  const [isServerError, setIsServerError] = useState(false);
  const [isExistingUserData, setIsExistingUserData] = useState(false);
  const [inputValue, setInputValue] = useState(''); // This will store the current input value for CustomFildForDetailQuestion
  const [isTermsChecked, setIsTermChecked] = useState({
    agreeTerm1: false,
    agreeTerm2: false,
    termsNotAgreedError: false,
  });
  const [validation, setValidation] = useState({
    isDOBValidated: {isTrue: true, errorMsg: ''},
    isDayValidated: {isTrue: true, errorMsg: ''},
    isMonthValidated: {isTrue: true, errorMsg: ''},
    isYearValidated: {isTrue: true, errorMsg: ''},
    isHeightValidated: {isTrue: true, errorMsg: ''},
    isWeightValidated: {isTrue: true, errorMsg: ''},
    isBMIValidated: {isTrue: true, errorMsg: ''},
  });
  const [formError, setFormError] = useState({
    name: '',
    email: '', // Error message for name field
    allergies: '',
    supplements: '',
    medicalCondition: '',
    wellnessGoal: '',
  });
  const [confirmDialog, setConfirmDialog] = useState({
    title: '',
    subTitle: '',
    isOpen: false,
  });
  const [userData, setUserData] = useState({
    dateOfBirth: null,
    dobDay: '',
    dobMonth: '',
    dobYear: '',
    gender: '',
    genderId: null,
    weight: '',
    height: {cm: '', ft: '', in: ''},
    isFrontendHeightImperialUnits: true,
    isFrontendWeightImperialUnits: true,
    ethnicity: '',
    isSmoker: '',
    diabetes: '',
    isPregnant: null,
    isPregnantId: null,
    menopauseStatus: null,
    menopauseStatusId: null,
    isHighBP: null,
    bpMeds: '',
    hasHadHeartAttack: '',
    hasHadStroke: '',
    checkedAgreementInfo: false,
    checkedTermsAndPrivacy: false,
    heightUnit: 'in',
    weightUnit: 'lbs',
    wellnessGoal: [],
    medicalCondition: [],
    allergies: [],
    isTakingSupplements: null,
    supplements: [],
    name: '',
    hasAllergies: null,
    medicalConditionNames: null,
  });

  //fetch ehincities & gender lists
  useEffect(() => {
    const fetchGenderEthnicityOptionList = async () => {
      try {
        // Fetch Ethnicities
        let ethnicitiesReq = await questionnaireApi.getEthnicities();
        if (ethnicitiesReq.status !== 200) {
          console.error('Failed to fetch ethnicities');
          return;
        }
        setEthnicitiesList(ethnicitiesReq.data);
        // Fetch Genders
        let genderReq = await questionnaireApi.getGenders();
        if (genderReq.status !== 200) {
          console.error('Failed to fetch genders');
          return;
        }
        // Map through the data and change "Intersex" to "Non-binary"
        const modifiedGenderList = genderReq.data.map(gender => {
          if (gender.id === 3 && gender.name === 'Intersex') {
            return {...gender, name: 'Non-Binary'}; // Replace "Intersex" with "Non-binary"
          }
          return gender;
        });
        setGenderList(modifiedGenderList);
      } catch (error) {
        setIsServerError(true);
        console.error('Error fetching gender and ethnicity options:', error);
      }
    };

    fetchGenderEthnicityOptionList();
  }, []);

  //checke preganenat id and update status accordingly
  useEffect(() => {
    if (userData.isPregnant) {
      setUserData(prev => ({
        ...prev,
        isPregnant: userData.isPregnantId === 1 || userData.isPregnantId === 2 ? true : false,
      }));
    }
  }, [userData.isPregnantId]);

  //Gets the existing demographics data of specific users
  useEffect(() => {
    const fetchData = async () => {
      let demographicsDataReq;
      let demographicsDataRes;
      try {
        setIsLoading(true);
        demographicsDataReq = await questionnaireApi.getQuestionnaire();
        if (typeof demographicsDataReq === 'string') {
          demographicsDataRes = JSON.parse(demographicsDataReq.data); // Parse the string response to JSON
        } else {
          demographicsDataRes = demographicsDataReq.data; // Directly use the response if it's already JSON
        }

        setIsExistingUserData(true);
      } catch (error) {
        setIsExistingUserData(false);
        setIsLoading(false);
        return;
      }
      const res = demographicsDataRes;
      let wellnessGoalarray = JSON.parse(demographicsDataRes.wellness_goals);
      let allergiesArray = JSON.parse(demographicsDataRes.allergy_name);
      let medicalConditionArray = JSON.parse(demographicsDataRes.medical_condition_name);
      let supplementsArray = JSON.parse(demographicsDataRes.supplement_name);

      // setDemographicsData(res.data);
      setUserData(obj => {
        const dobDate = dayjs(demographicsDataRes.date_of_birth);
        obj.dateOfBirth = dobDate;
        // Populate individual date fields for large screens
        if (dobDate.isValid()) {
          obj.dobDay = dobDate.format('DD');
          obj.dobMonth = dobDate.format('MM');
          obj.dobYear = dobDate.format('YYYY');
        }
        obj.gender = demographicsDataRes.gender_id;
        obj.isSmoker = demographicsDataRes.is_smoker;
        obj.isFrontendHeightImperialUnits = demographicsDataRes.is_frontend_height_imperial_units ?? true;
        obj.isFrontendWeightImperialUnits = demographicsDataRes.is_frontend_weight_imperial_units ?? true;
        obj.ethnicity = demographicsDataRes.ethnicity_id;
        obj.diabetes = demographicsDataRes.diabetes_type_id;
        obj.isHighBP = demographicsDataRes.has_high_bp;
        obj.bpMeds = demographicsDataRes.is_on_bp_meds;
        obj.isPregnant = demographicsDataRes.pregnant;
        obj.isPregnantId = demographicsDataRes.pregnant ? 1 : 3;
        obj.hasHadStroke = demographicsDataRes.has_had_stroke;
        obj.hasHadHeartAttack = demographicsDataRes.has_had_heart_attack;
        obj.weightUnit = demographicsDataRes.is_frontend_weight_imperial_units ? 'lbs' : 'kg';
        ((obj.heightUnit = demographicsDataRes.is_frontend_height_imperial_units ? 'in' : 'cm'),
          (obj.wellnessGoal = wellnessGoalarray ? wellnessGoalarray : []),
          (obj.allergies = allergiesArray ? allergiesArray : []),
          (obj.medicalCondition = medicalConditionArray ? medicalConditionArray : []));

        obj.menopauseStatus = demographicsDataRes.menopausal_status || null;

        // obj.has = res.data. ,
        ((obj.isTakingSupplements = demographicsDataRes.has_supplement),
          (obj.supplements = supplementsArray ? supplementsArray : []));

        // Convert height based on saved preference or default to imperial
        if (demographicsDataRes.is_frontend_height_imperial_units ?? true) {
          const feetAndInches = convertCentimetersToFeetAndInches(demographicsDataRes.height);
          obj.height.ft = feetAndInches.feet;
          obj.height.in = feetAndInches.inches;
        } else {
          obj.height.cm = demographicsDataRes.height;
        }

        // Convert weight based on saved preference or default to imperial
        obj.weight =
          (demographicsDataRes.is_frontend_weight_imperial_units ?? true)
            ? convertKilogramsToPounds(demographicsDataRes.weight)
            : demographicsDataRes.weight;

        return obj;
      });

      const {comingFromPreScanPage} = location.state || {};
      comingFromPreScanPage
        ? demographicsDataRes.has_supplement
          ? setCurrentStep(16)
          : setCurrentStep(15)
        : setCurrentStep(1);
      setIsLoading(false);
    };

    if (isUserFlow) {
      fetchData();
    }
  }, [isUserFlow]);

  // Trigger validation  when userData.dateOfBirth changes, but skip on initial render
  useEffect(() => {
    if (isDobFirstInteraction) {
      return; // Skip validation on initial render
    }
    // Trigger validation after change
    const {validation: updatedValidation} = validateForm();
    setValidation(updatedValidation);
  }, [userData.dateOfBirth, isDobFirstInteraction]);

  useEffect(() => {
    if (startSubmitData) {
      handleLetsGoPreScanBtn();
    }
  }, [startSubmitData]);

  //Handle agree terms & condition logic
  const handleCheckboxChange = event => {
    const {name, checked} = event.target;

    // Update the specific checkbox without affecting the others
    setIsTermChecked(prevState => ({
      ...prevState,
      [name]: checked,
    }));
  };

  //handle form data submitt
  const handleLetsGoPreScanBtn = async () => {
    try {
      const {weight, height} = userData;

      // Format date consistently with ATP - ensure it's in the same format as ATP's birthDate
      const formattedDateOfBirth = userData.dateOfBirth
        ? dayjs(userData.dateOfBirth).format('YYYY-MM-DD')
        : userData.dateOfBirth;

      // Prepare the request data
      const requestData = {
        dateOfBirth: formattedDateOfBirth,
        gender: userData.gender,
        ethnicity: userData.ethnicity,
        height: userData.isFrontendHeightImperialUnits
          ? convertFeetAndInchesToCentimeters(Number(height.ft), Number(height.in))
          : Number(height.cm),
        weight: userData.isFrontendWeightImperialUnits ? convertPoundsToKilograms(Number(weight)) : Number(weight),
        isFrontendHeightImperialUnits: userData.isFrontendHeightImperialUnits,
        isFrontendWeightImperialUnits: userData.isFrontendWeightImperialUnits,
        isSmoker: userData.isSmoker,
        diabetes: userData.diabetes,
        isHighBP: userData.isHighBP,
        bpMeds: userData.bpMeds,
        isPregnant: userData.isPregnant,
        menopauseStatus: userData.menopauseStatus,
        hasHadStroke: userData.hasHadStroke,
        hasHadHeartAttack: userData.hasHadHeartAttack,
        wellnessGoals: userData.wellnessGoal?.length > 0 ? userData.wellnessGoal : null,
        hasMedicalCondition: userData.medicalCondition?.length > 0 ? true : false,
        medicalConditionNames: userData?.medicalCondition?.length ? userData.medicalCondition : null, // if no medical condition added, send null
        hasAllergies: userData.allergies?.length > 0 ? true : false,
        allergyNames: userData.allergies?.length > 0 ? userData.allergies : null, // if no allergy aded ,send null
        hasSupplements: userData.isTakingSupplements, // since its not immeditely update passing it directly
        supplements: userData.isTakingSupplements ? userData.supplements : null, // if select not taking supplement send null
      };

      // Set loading state before API call
      setIsLoading(true);

      // Choose the appropriate API method (PATCH or POST)
      const apiMethod = isExistingUserData ? questionnaireApi.patchQuestionnaire : questionnaireApi.postQuestionnaire;

      // Call the API
      await apiMethod(
        requestData.dateOfBirth,
        requestData.gender,
        requestData.ethnicity,
        requestData.height,
        requestData.weight,
        requestData.isFrontendHeightImperialUnits,
        requestData.isFrontendWeightImperialUnits,
        requestData.isSmoker,
        requestData.diabetes,
        requestData.isHighBP,
        requestData.bpMeds,
        requestData.isPregnant,
        requestData.menopauseStatus, // Add menopause parameter
        requestData.hasHadStroke,
        requestData.hasHadHeartAttack,
        requestData.wellnessGoals,
        requestData.hasMedicalCondition,
        requestData.medicalConditionNames,
        requestData.hasAllergies,
        requestData.allergyNames,
        requestData.hasSupplements, // if select not taking supplement send null
        requestData.supplements, // if select not taking supplement send null
      );

      // Navigate to the next page
      navigate('/skyn-condition-checker', {
        state: {isComingFromDemographicsPage: true},
      });
    } catch (error) {
      setIsLoading(false); // Stop loading spinner
      setIsServerError(true); // Show server error state
    } finally {
      // Ensure that loading state is reset, even if an error occurs
      if (isLoading) {
        setIsLoading(false);
      }
    }
  };

  //Handles action to close terms of use modal dialog
  const closeTermsModal = isClose => {
    setOpenModalTerms(isClose);
  };

  //Handles action to close privacy policy modal dialog
  const closePrivacyPolicyModal = isClose => {
    setOpenModalPrivacy(isClose);
  };

  //Handles action to open privacy policy modal dialog
  const handlePrivacyPolicy = () => {
    setOpenModalPrivacy(true);
  };

  //Handles action to open terms of use modal dialog
  const handleTermsOfUse = () => {
    setOpenModalTerms(true);
  };

  //help with bmi calculation & show appropriate bmi validation error
  const calculateValidRanges = userData => {
    // Constants for BMI limits
    const MIN_BMI = 10;
    const MAX_BMI = 65;

    // Get current values in metric
    let heightInCm =
      userData.heightUnit === 'cm'
        ? Number(userData.height.cm)
        : convertFeetAndInchesToCentimeters(Number(userData.height.ft), Number(userData.height.in));

    // Calculate valid weight range for current height
    const heightInMeters = heightInCm / 100;
    let minWeight = MIN_BMI * (heightInMeters * heightInMeters);
    let maxWeight = MAX_BMI * (heightInMeters * heightInMeters);

    // Apply absolute limits in kg first
    minWeight = Math.max(minWeight, VALIDATION_LIMITS.WEIGHT.KG.MIN);
    maxWeight = Math.min(maxWeight, VALIDATION_LIMITS.WEIGHT.KG.MAX);

    return {
      weightRanges: {
        min: userData.weightUnit === 'kg' ? Math.round(minWeight) : Math.round(convertKilogramsToPounds(minWeight)),
        max: userData.weightUnit === 'kg' ? Math.round(maxWeight) : Math.round(convertKilogramsToPounds(maxWeight)),
        unit: userData.weightUnit,
      },
    };
  };

  //Handle validation for dob,height,weight
  const validateForm = () => {
    let hasError = false;
    const updatedValidation = {...validation};

    const validateWeight = (weight, weightUnit) => {
      const weightValue = Number(weight);
      const weightInKg = weightUnit === 'kg' ? weightValue : convertPoundsToKilograms(weightValue);
      return weightInKg >= 30 && weightInKg <= 300;
    };

    const validateHeight = (height, heightUnit) => {
      let heightInCm;
      if (heightUnit === 'cm') {
        heightInCm = Number(height.cm);
      } else {
        heightInCm = convertFeetAndInchesToCentimeters(Number(height.ft), Number(height.in));
      }
      return heightInCm >= 120 && heightInCm <= 220;
    };
    // Function to calculate age based on date of birth
    const calculateAge = dob => {
      const today = new Date();
      const birthDate = new Date(dob);
      let age = today.getFullYear() - birthDate.getFullYear();
      const m = today.getMonth() - birthDate.getMonth();

      // Adjust age if the birth month/day hasn't passed yet this year
      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }

      return age;
    };

    // Check current step and validate accordingly

    // Date of Birth validation (Step 2)
    if (currentStep === 2) {
      if (isLaptop) {
        // For large screens, validate individual date fields
        const dateValidation = validateDateFields();
        Object.assign(updatedValidation, dateValidation.validation);
        if (!dateValidation.isValid) {
          hasError = true;
        }
      } else {
        // For mobile screens, validate dateOfBirth
        if (!userData.dateOfBirth) {
          updatedValidation.isDOBValidated = {isTrue: false, errorMsg: 'Please select your date of birth.'};
          hasError = true;
        } else {
          // Validate if the date is a valid date
          if (!dayjs(userData.dateOfBirth).isValid()) {
            updatedValidation.isDOBValidated = {isTrue: false, errorMsg: 'Please enter a valid date of birth.'};
            hasError = true;
          } else {
            // Check if the user is at least 13 years old
            const age = calculateAge(userData.dateOfBirth);
            if (age < 13 || age > 120) {
              updatedValidation.isDOBValidated = {isTrue: false, errorMsg: 'Age must be between 13 and 120 years.'};
              hasError = true;
            } else {
              updatedValidation.isDOBValidated = {isTrue: true, errorMsg: ''};
            }
          }
        }
      }
    }

    // Step 2: Height & Weight validation
    if (currentStep === 3) {
      //height validation
      if (
        !userData.height ||
        (userData.heightUnit === 'in' && (!userData.height.ft || !userData.height.in)) ||
        (userData.heightUnit === 'cm' && !userData.height.cm)
      ) {
        updatedValidation.isHeightValidated = {isTrue: false, errorMsg: 'Please enter your height.'};
        hasError = true;
      } else if (userData.heightUnit === 'in' && !validateHeight(userData.height, userData.heightUnit)) {
        // If height is in feet and it's invalid, show error in ft
        updatedValidation.isHeightValidated = {isTrue: false, errorMsg: 'Height must be between 4 ft and 7 ft.'};
        hasError = true;
      } else if (userData.heightUnit === 'cm' && !validateHeight(userData.height, userData.heightUnit)) {
        // If height is in cm and it's invalid, show error in cm
        updatedValidation.isHeightValidated = {isTrue: false, errorMsg: 'Height must be between 120cm and 220cm.'};
        hasError = true;
      } else {
        updatedValidation.isHeightValidated = {isTrue: true, errorMsg: ''};
      }

      //weight validation
      if (!userData.weight) {
        updatedValidation.isWeightValidated = {isTrue: false, errorMsg: 'Please enter your weight.'};
        hasError = true;
      } else if (userData.weightUnit === 'lbs' && (userData.weight < 65 || userData.weight > 600)) {
        // Show weight error in lbs if it's outside the lbs range (30kg to 300kg in lbs)
        updatedValidation.isWeightValidated = {isTrue: false, errorMsg: 'Weight must be between 65 lbs and 600 lbs.'};
        hasError = true;
      } else if (userData.weightUnit === 'kg' && !validateWeight(userData.weight, userData.weightUnit)) {
        // If weight is in kg and it's invalid, show error in kg
        updatedValidation.isWeightValidated = {isTrue: false, errorMsg: 'Weight must be between 30kg and 300kg.'};
        hasError = true;
      } else {
        updatedValidation.isWeightValidated = {isTrue: true, errorMsg: ''};
      }

      // BMI Validation (calculation directly inside validation function)
      let weightInKg = userData.isFrontendWeightImperialUnits
        ? convertPoundsToKilograms(userData.weight)
        : userData.weight;
      let heightInCm = userData.isFrontendHeightImperialUnits
        ? convertFeetAndInchesToCentimeters(Number(userData.height.ft), Number(userData.height.in))
        : Number(userData.height.cm);

      let BMI = calculateBMIMetricUnit(weightInKg, heightInCm);

      let BMIValidation = BMI >= 10 && BMI <= 65;
      if (!BMIValidation) {
        hasError = true;

        let {weightRanges} = calculateValidRanges(userData);
        if (userData.heightUnit === 'cm') {
          updatedValidation.isBMIValidated = {
            isTrue: false,
            errorMsg: `Height and weight combination results in an invalid BMI. For your height of ${heightInCm} cm, please adjust weight to between ${weightRanges.min} ${weightRanges.unit} and ${weightRanges.max} ${weightRanges.unit}.`,
          };
        } else {
          const ft = userData.height.ft;
          const inches = userData.height.in;
          updatedValidation.isBMIValidated = {
            isTrue: false,
            errorMsg: `Height and weight combination results in an invalid BMI. For your height of ${ft}'${inches}", please adjust weight to between ${weightRanges.min} ${weightRanges.unit} and ${weightRanges.max} ${weightRanges.unit}.`,
          };
        }

        hasError = true;
      } else {
        updatedValidation.isBMIValidated = {isTrue: true, errorMsg: ''};
      }
    }

    // Return the validation state and whether the form is valid or not
    return {isValid: !hasError, validation: updatedValidation};
  };

  // Callback function that will be passed to the ScrollableDatePicker
  const handleDateChange = date => {
    setUserData(prev => ({
      ...prev,
      dateOfBirth: date,
    }));
  };

  // Handle individual date field changes for large screens
  const handleDateInputChange = (field, value) => {
    // Remove any non-numeric characters
    const numericValue = value.replace(/\D/g, '');

    // Apply length limits
    let limitedValue = numericValue;
    if (field === 'dobDay' || field === 'dobMonth') {
      limitedValue = numericValue.slice(0, 2);
    } else if (field === 'dobYear') {
      limitedValue = numericValue.slice(0, 4);
    }

    // Clear validation errors as user types
    setValidation(prev => ({
      ...prev,
      isDayValidated: {isTrue: true, errorMsg: ''},
      isMonthValidated: {isTrue: true, errorMsg: ''},
      isYearValidated: {isTrue: true, errorMsg: ''},
      isDOBValidated: {isTrue: true, errorMsg: ''},
    }));

    // Update user data and create date object if all fields are filled
    setUserData(prev => {
      const newData = {
        ...prev,
        [field]: limitedValue,
      };

      // Check if all date fields are filled
      if (newData.dobDay && newData.dobMonth && newData.dobYear) {
        const dateString = `${newData.dobYear}-${newData.dobMonth.padStart(2, '0')}-${newData.dobDay.padStart(2, '0')}`;
        const dateObj = dayjs(dateString);
        if (dateObj.isValid()) {
          newData.dateOfBirth = dateObj;
        }
      }

      return newData;
    });
  };

  // Validate individual date fields
  const validateDateFields = () => {
    const currentYear = new Date().getFullYear();
    const updatedValidation = {...validation};
    let hasError = false;

    // Validate day
    const day = parseInt(userData.dobDay);
    if (!userData.dobDay) {
      updatedValidation.isDayValidated = {isTrue: false, errorMsg: 'Day required'};
      hasError = true;
    } else if (day < 1 || day > 31) {
      updatedValidation.isDayValidated = {isTrue: false, errorMsg: 'Invalid day'};
      hasError = true;
    } else {
      updatedValidation.isDayValidated = {isTrue: true, errorMsg: ''};
    }

    // Validate month
    const month = parseInt(userData.dobMonth);
    if (!userData.dobMonth) {
      updatedValidation.isMonthValidated = {isTrue: false, errorMsg: 'Month required'};
      hasError = true;
    } else if (month < 1 || month > 12) {
      updatedValidation.isMonthValidated = {isTrue: false, errorMsg: 'Invalid month'};
      hasError = true;
    } else {
      updatedValidation.isMonthValidated = {isTrue: true, errorMsg: ''};
    }

    // Validate year
    const year = parseInt(userData.dobYear);
    if (!userData.dobYear) {
      updatedValidation.isYearValidated = {isTrue: false, errorMsg: 'Year required'};
      hasError = true;
    } else if (year < 1900 || year > currentYear) {
      updatedValidation.isYearValidated = {isTrue: false, errorMsg: `Year must be between 1900-${currentYear}`};
      hasError = true;
    } else {
      updatedValidation.isYearValidated = {isTrue: true, errorMsg: ''};
    }

    // Validate complete date if individual fields are valid
    if (!hasError) {
      const dateString = `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`;
      const dateObj = dayjs(dateString);

      if (!dateObj.isValid()) {
        updatedValidation.isDOBValidated = {isTrue: false, errorMsg: 'Invalid date combination'};
        hasError = true;
      } else {
        // Check age
        const age = currentYear - year;
        const hasHadBirthday = dayjs().isAfter(dateObj.add(age, 'year'));
        const actualAge = hasHadBirthday ? age : age - 1;

        if (actualAge < 13 || actualAge > 120) {
          updatedValidation.isDOBValidated = {isTrue: false, errorMsg: 'Age must be between 13 and 120 years'};
          hasError = true;
        } else {
          updatedValidation.isDOBValidated = {isTrue: true, errorMsg: ''};
          // Update dateOfBirth if valid
          setUserData(prev => ({
            ...prev,
            dateOfBirth: dateObj,
          }));
        }
      }
    }

    return {isValid: !hasError, validation: updatedValidation};
  };

  const handleHeightChange = (e, field) => {
    const {value} = e.target;

    // Update the height field (either ft, in, or cm)
    setUserData(prev => ({
      ...prev,
      height: {...prev.height, [field]: value}, // Dynamically set the field value
    }));

    // Clear the error message for the specific field (ft, in, or cm)
    setValidation(prev => ({
      ...prev,
      isHeightValidated: {isTrue: true, errorMsg: ''}, // Clear general height validation error
      isBMIValidated: {isTrue: true, errorMsg: ''}, // Reset BMI validation error
    }));
  };

  const handleWeightChange = e => {
    const {value} = e.target;

    // Update the weight in userData
    setUserData(prev => ({
      ...prev,
      weight: value, // Update weight value
    }));

    // Clear the error message for weight validation
    setValidation(prev => ({
      ...prev,
      isWeightValidated: {isTrue: true, errorMsg: ''}, // Reset weight validation error
      isBMIValidated: {isTrue: true, errorMsg: ''}, // Reset BMI validation error
    }));
  };

  const isValidName = name => {
    // Ensure `name` is a string before applying `trim()`
    const trimmedName = name?.trim();
    const namePattern = /^[A-Za-zÀ-ÿ\s]+$/;

    // Check if trimmedName is a non-empty string and matches the pattern
    return trimmedName && namePattern.test(trimmedName);
  };

  // Next step logic
  const handleNextStep = fieldRequiredValidation => {
    const {isValid, validation: updatedValidation} = validateForm(fieldRequiredValidation);

    // Set the validation state with the updated error messages
    setValidation(updatedValidation);

    // If the form is valid, proceed to the next step
    if (isValid) {
      handleNavigationOnAnotherPAge();
      // setCurrentStep(prev => prev + 1); // Move to the next step
    }
  };

  const clearAllFormError = () => {
    setFormError({
      name: '',
      email: '', // Error message for name field
      allergies: '',
      supplements: '',
      medicalCondition: '',
    });
  };

  //weight/Height unit change logic
  const handleUnitChange = (event, newUnit, type) => {
    if (!newUnit) return; // If no new unit is selected, do nothing

    //reset validation state when unit changes
    setValidation(prevValidation => ({
      ...prevValidation,
      isWeightValidated: {isTrue: true, errorMsg: ''},
      isHeightValidated: {isTrue: true, errorMsg: ''},
      isBMIValidated: {isTrue: true, errorMsg: ''},
    }));

    setUserData(prevUserData => {
      const newState = {...prevUserData};
      if (type === 'height') {
        newState.heightUnit = newUnit; // Update the height unit in userData
        newState.height = {ft: '', in: '', cm: ''}; // Reset height value
        newState.isFrontendHeightImperialUnits = newUnit === 'in';
      } else if (type === 'weight') {
        newState.weightUnit = newUnit; // Update the weight unit in userData
        newState.weight = ''; // Reset weight value
        newState.isFrontendWeightImperialUnits = newUnit === 'lbs';
      }
      return newState;
    });
  };

  //update userData value state by passing field & value string
  const handleOptionSelect = (field, value) => {
    setUserData(prev => ({
      ...prev,
      [field]: value,
    }));

    if (field == 'isHighBP' && !value) {
      setUserData(prevState => ({
        ...prevState,
        bpMeds: false,
      }));
      setCurrentStep(prev => prev + 2);
    }
    // if user not taking any supplements don't show him add supplements screen
    else if (field == 'isTakingSupplements' && !value) {
      setCurrentStep(prev => prev + 2);
      setUserData(prevState => ({
        ...prevState,
        supplements: [],
      }));
      setStartSubmitData(true);
    }
    // Handle pregnancy selection - if not pregnant (option 3), show menopause screen
    else if (field === 'isPregnantId') {
      if (value === 3) {
        // "No, I am not pregnant"
        // Show menopause screen next
        handleNavigationOnAnotherPAge();
      } else {
        // If pregnant or breastfeeding, skip menopause screen
        setCurrentStep(prev => prev + 2);
      }
    }
    // if user is male don't show isPregnant Question and by default set it to false
    else if (currentStep == 3 && userData.gender == 1) {
      setUserData(prevState => ({
        ...prevState,
        isPregnant: false,
      }));
      setCurrentStep(prev => prev + 2);
    } else {
      handleNavigationOnAnotherPAge();
    }
  };

  const backButtonHandler = () => {
    if (currentStep > 1) {
      if (currentStep == 5 && userData.gender === 1) {
        setCurrentStep(prev => prev - 2);
      } else if (currentStep == 6 && userData.gender === 2 && userData.isPregnantId !== 3) {
        // If going back from step 6 and user is female but pregnant/breastfeeding
        setCurrentStep(prev => prev - 2);
      } else if (currentStep == 10 && !userData.isHighBP) {
        setCurrentStep(prev => prev - 2);
      } else if (currentStep == 16 && !userData.isTakingSupplements) {
        setCurrentStep(prev => prev - 2);
      } else {
        setCurrentStep(prev => prev - 1);
      }
    }
  };

  //handle wellness goal selection
  const handleOptionToggle = value => {
    //clear form error
    // clearAllFormError();
    setUserData(prevState => {
      // Ensure wellnessGoal is always an array (default to empty array if undefined or not an array)
      const wellnessGoal = Array.isArray(prevState?.wellnessGoal) ? prevState.wellnessGoal : [];

      // Toggle the value
      const newGoals = wellnessGoal.includes(value)
        ? wellnessGoal.filter(goal => goal !== value) // Deselect if already selected
        : [...wellnessGoal, value]; // Select if not selected

      return {
        ...prevState,
        wellnessGoal: newGoals,
      };
    });
  };

  // Handles selection of a suggested option for a specific field
  const handleSuggestedOptionSelect = (field, option, availableOptions) => {
    // Ensure that the field exists and is an array
    const currentFieldData = Array.isArray(userData[field]) ? userData[field] : [];

    // Check if the option is already added to avoid duplicates
    if (!currentFieldData.includes(option)) {
      setUserData(prev => ({
        ...prev,
        [field]: Array.isArray(prev[field]) ? [...prev[field], option] : [option], // Ensure prev[field] is an array
      }));
    }

    // Clear the input field after selection
    setInputValue('');

    // Reset filtered options based on the selected field
    setFilteredOptions(availableOptions); // Reset only the options for the selected field
  };

  // Handles input change for fields like allergy, medication, and supplement
  const CustomFildForDetailQuestionInputChange = (e, field, relatedsuggestionList) => {
    const newValue = e.target.value;
    setInputValue(newValue);
    let filtered = [];
    // Filter the available options based on the input value (case-insensitive match)
    filtered = relatedsuggestionList.filter(
      option => option.toLowerCase().includes(newValue.toLowerCase()), // Filter options by containing match
    );

    // Update the filtered options state
    setFilteredOptions(filtered);

    // Clear form errors as the user starts typing
    clearAllFormError();
  };

  // Function to handle dynamic field update on "Enter" key press
  const CustomFieldForDetailQuestionKeyPress = (e, field) => {
    // Check if the "Enter" key is pressed and input is not empty
    if (e.key === 'Enter' && inputValue.trim() !== '') {
      updateListInputsValue(e, field);
      clearAllFormError();
    }
  };

  // dynamically Remove item from userdata fields with array option
  const onCloseIconClickInOptionArrayList = (itemToRemove, field) => {
    setUserData(prevState => {
      const updatedField = prevState[field].filter(item => item !== itemToRemove);
      return {
        ...prevState,
        [field]: updatedField,
      };
    });
  };

  //this fn will handle add btn click logic for add allergy,medication to list
  const onAddBtnClick = (e, field) => {
    if (inputValue.trim() !== '') {
      updateListInputsValue(e, field);
      clearAllFormError();
    }
  };

  const updateListInputsValue = (e, field) => {
    setUserData(prevState => {
      // Dynamically update the field (using bracket notation to access field dynamically)
      const updatedField = prevState[field] ? [...prevState[field], inputValue.trim()] : [inputValue.trim()];
      return {
        ...prevState,
        [field]: updatedField, // Dynamically set the field value
      };
    });

    // Reset input value after adding to the array
    setInputValue('');
  };

  const handleInputChange = (field, value) => {
    setUserData(prev => ({
      ...prev,
      [field]: value,
    }));
    clearAllFormError(); //clear error as user start typing
  };

  const handleNextStepInCustomFiledComponent = field => {
    let isValid = true;

    // Validate name
    if (field === 'name' && !isValidName(userData.name)) {
      setFormError(prevState => ({
        ...prevState,
        [field]: 'Please enter a valid name. (Only letters and spaces are allowed)',
      }));
      isValid = false;
    }

    // Validate array fields (e.g., medicalCondition, allergies, supplements)
    if (field === 'medicalCondition' || field === 'allergies' || field === 'supplements') {
      if (!userData[field]?.length) {
        setFormError(prevState => ({
          ...prevState,
          [field]: 'Please add details',
        }));
        isValid = false;
      }
    }

    if (field === 'wellnessGoal') {
      if (!userData[field]?.length) {
        setFormError(prevState => ({
          ...prevState,
          wellnessGoal: 'Please select your goal',
        }));
        isValid = false;
      }
    }

    // If all fields are valid, proceed to the next step
    if (isValid) {
      proceedToNextStep(field);
    }
  };

  const proceedToNextStep = field => {
    // Clearing all errors before proceeding
    clearAllFormError();

    // Reset additional input fields if necessary (e.g., multiple-choice selections)
    clearMultipleAnswerInput();

    //last step submitt data and move pre-scan
    if (currentStep === 16 && field === 'supplements') {
      handleLetsGoPreScanBtn();
    } else {
      // Moving to the next step
      handleNavigationOnAnotherPAge();
    }
  };

  const clearMultipleAnswerInput = () => {
    setInputValue('');
  };

  const handleSkip = field => {
    clearAllFormError();
    if (field === 'name' || field === 'email') {
      setUserData(prevState => ({
        ...prevState,
        [field]: '', // Set the specific field to an empty string
      }));
    }
    if (field === 'medicalCondition' || field === 'allergies' || field === 'supplements' || field === 'wellnessGoal') {
      setUserData(prevState => ({
        ...prevState,
        [field]: [], // Set the specific field to an empty array
      }));
    }

    handleNavigationOnAnotherPAge();
  };

  const handleNavigationOnAnotherPAge = () => {
    if (currentStep == 3 && userData.gender == 1) {
      setUserData(prevState => ({
        ...prevState,
        isPregnant: false,
      }));
      setCurrentStep(prev => prev + 2);
    } else {
      setCurrentStep(prev => prev + 1);
    }
  };

  //thia will set custmise style for height & weight measure type btn
  const toggleButtonStyles = {
    width: isLaptop ? '50px' : '32px',
    height: isLaptop ? '32px' : '27px',
    color: '#000000',
    fontSize: isLaptop ? '16px' : '12px',
    fontWeight: '500',
    '&.Mui-selected': {
      backgroundColor: '#72D8DA',
      color: 'white',
    },
    '&.Mui-selected:hover': {
      backgroundColor: '#72D8DA',
      color: 'white',
    },
  };

  //JSX to show error msgs
  const CommonErrorMessage = ({text}) => {
    return (
      <Typography
        variant="caption"
        color="error"
        display="flex"
        textAlign="start"
        gutterBottom
        sx={{
          fontSize: {
            xs: '12px',
            sm: '12px',
            md: '16px',
            lg: '16px',
          },
          padding: '4px 0px 0px 0px', // Padding for the text
          gutterBottom: true, // This adds bottom spacing
        }}
      >
        {text}
      </Typography>
    );
  };

  const renderStep = () => {
    switch (currentStep) {
      case 0:
        return renderStep1();
      case 1:
        return renderStep1();
      case 2:
        return renderStep2();
      case 3:
        return renderStep3();
      case 4:
        return renderStep4(); // Pregnancy screen
      case 5:
        return renderStep5(); // NEW: Menopause screen
      case 6:
        return renderStep6(); // Smoking (was step 5)
      case 7:
        return renderStep7(); // Ethnicity (was step 6)
      case 8:
        return renderStep8(); // Diabetes (was step 7)
      case 9:
        return renderStep9(); // High BP (was step 8)
      case 10:
        return renderStep10(); // BP Meds (was step 9)
      case 11:
        return renderStep11(); // Heart Attack (was step 10)
      case 12:
        return renderStep12(); // Stroke (was step 11)
      case 13:
        return renderStep13(); // Name (was step 12)
      case 14:
        return renderStep14(); // Wellness Goals (was step 13)
      case 15:
        return renderStep15(); // Medical Conditions (was step 14)
      case 16:
        return renderStep16(); // Allergies (was step 15)
      case 17:
        return renderStep17(); // Supplements question (was step 16)
      default:
        return null;
    }
  };

  const renderStep1 = () => (
    <StepContainer title="Are you...">
      <Stack marginTop="10px">
        {genderList.map((option, index) => (
          <UserDemographicOptionButton
            key={index}
            option={option.name}
            onClick={() => handleOptionSelect('gender', option.id)}
            selctedValue={userData.gender}
            value={option.id}
          />
        ))}
      </Stack>
    </StepContainer>
  );

  const renderStep2 = () => (
    <StepContainer title="What is your date of birth?">
      <Stack
        sx={{
          width: {
            xs: '300px',
            sm: '300px',
            md: '350px',
            lg: '400px',
          },
          marginY: '30px',
        }}
      >
        {isLaptop ? (
          <Box sx={{marginTop: '20px'}}>
            <Box sx={{display: 'flex', gap: 2, justifyContent: 'center', alignItems: 'flex-start'}}>
              {/* Day Input */}
              <Box sx={{display: 'flex', flexDirection: 'column'}}>
                <TextField
                  label="DD"
                  variant="outlined"
                  type="text"
                  value={userData.dobDay}
                  onChange={e => handleDateInputChange('dobDay', e.target.value)}
                  inputProps={{maxLength: 2}}
                  sx={{
                    width: '80px',
                    '& .MuiOutlinedInput-root': {
                      borderRadius: '8px',
                      '& fieldset': {
                        borderColor: '#72D8DA',
                      },
                      '&:hover fieldset': {
                        borderColor: '#35C6C9',
                      },
                      '&.Mui-focused fieldset': {
                        borderColor: '#72D8DA',
                        borderWidth: '2px',
                      },
                    },
                    '& .MuiInputLabel-root': {
                      color: '#72D8DA',
                      '&.Mui-focused': {
                        color: '#72D8DA',
                      },
                    },
                    '& .MuiInputBase-input': {
                      textAlign: 'center',
                      fontSize: '16px',
                      fontWeight: '500',
                    },
                  }}
                />
                {!validation.isDayValidated.isTrue && (
                  <CommonErrorMessage text={validation.isDayValidated.errorMsg} sx={{fontSize: '12px', mt: 1}} />
                )}
              </Box>

              {/* Month Input */}
              <Box sx={{display: 'flex', flexDirection: 'column'}}>
                <TextField
                  label="MM"
                  variant="outlined"
                  type="text"
                  value={userData.dobMonth}
                  onChange={e => handleDateInputChange('dobMonth', e.target.value)}
                  inputProps={{maxLength: 2}}
                  sx={{
                    width: '80px',
                    '& .MuiOutlinedInput-root': {
                      borderRadius: '8px',
                      '& fieldset': {
                        borderColor: '#72D8DA',
                      },
                      '&:hover fieldset': {
                        borderColor: '#35C6C9',
                      },
                      '&.Mui-focused fieldset': {
                        borderColor: '#72D8DA',
                        borderWidth: '2px',
                      },
                    },
                    '& .MuiInputLabel-root': {
                      color: '#72D8DA',
                      '&.Mui-focused': {
                        color: '#72D8DA',
                      },
                    },
                    '& .MuiInputBase-input': {
                      textAlign: 'center',
                      fontSize: '16px',
                      fontWeight: '500',
                    },
                  }}
                />
                {!validation.isMonthValidated.isTrue && (
                  <CommonErrorMessage text={validation.isMonthValidated.errorMsg} sx={{fontSize: '12px', mt: 1}} />
                )}
              </Box>

              {/* Year Input */}
              <Box sx={{display: 'flex', flexDirection: 'column'}}>
                <TextField
                  label="YYYY"
                  variant="outlined"
                  type="text"
                  value={userData.dobYear}
                  onChange={e => handleDateInputChange('dobYear', e.target.value)}
                  inputProps={{maxLength: 4}}
                  sx={{
                    width: '100px',
                    '& .MuiOutlinedInput-root': {
                      borderRadius: '8px',
                      '& fieldset': {
                        borderColor: '#72D8DA',
                      },
                      '&:hover fieldset': {
                        borderColor: '#35C6C9',
                      },
                      '&.Mui-focused fieldset': {
                        borderColor: '#72D8DA',
                        borderWidth: '2px',
                      },
                    },
                    '& .MuiInputLabel-root': {
                      color: '#72D8DA',
                      '&.Mui-focused': {
                        color: '#72D8DA',
                      },
                    },
                    '& .MuiInputBase-input': {
                      textAlign: 'center',
                      fontSize: '16px',
                      fontWeight: '500',
                    },
                  }}
                />
                {!validation.isYearValidated.isTrue && (
                  <CommonErrorMessage text={validation.isYearValidated.errorMsg} sx={{fontSize: '12px', mt: 1}} />
                )}
              </Box>
            </Box>

            {/* General date validation error */}
            {!validation.isDOBValidated.isTrue && (
              <Box sx={{mt: 2, textAlign: 'center'}}>
                <CommonErrorMessage text={validation.isDOBValidated.errorMsg} />
              </Box>
            )}
          </Box>
        ) : (
          <Box sx={{marginTop: '20px'}}>
            <ScrollableDatePicker onDateChange={handleDateChange} initialDate={userData.dateOfBirth} />
          </Box>
        )}

        {/* Mobile validation error */}
        {!isLaptop && (
          <Box sx={{marginTop: '50px'}}>
            <CommonErrorMessage text={!validation.isDOBValidated.isTrue && validation.isDOBValidated.errorMsg} />
          </Box>
        )}

        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          marginTop={{
            xs: '80px',
            sm: '90px',
            md: '130px',
            lg: '150px',
          }}
        >
          <NextButtonDefault onClick={() => handleNextStep()} />
        </Box>
      </Stack>
    </StepContainer>
  );

  const renderStep3 = () => (
    <StepContainer title="What is your height and weight?">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          width: isLaptop ? '450px' : '300px',
        }}
      >
        {/* Height Section */}
        <Box marginBottom="20px">
          <Stack display="flex" flexDirection="row" justifyContent="space-between" alignItems="center">
            <Typography sx={{mb: 1, fontSize: '17px', fontWeight: '500'}}>Height</Typography>
            <ToggleButtonGroup
              value={userData.heightUnit}
              exclusive
              onChange={(event, newUnit) => handleUnitChange(event, newUnit, 'height')}
              sx={{mb: 2}}
            >
              <ToggleButton value="in" sx={toggleButtonStyles}>
                in
              </ToggleButton>
              <ToggleButton value="cm" sx={toggleButtonStyles}>
                cm
              </ToggleButton>
            </ToggleButtonGroup>
          </Stack>
          {userData.heightUnit === 'in' ? (
            <Box sx={{display: 'flex', gap: 2}}>
              <TextField
                label="ft"
                variant="standard"
                type="number"
                value={userData.height.ft}
                sx={measurementLabelStyle}
                InputLabelProps={{shrink: false}}
                onChange={e => handleHeightChange(e, 'ft')} // Call handler with field 'ft'
                fullWidth
              />

              <TextField
                label="in"
                variant="standard"
                type="number"
                sx={measurementLabelStyle}
                InputLabelProps={{
                  shrink: false, // Prevent the label from shrinking on focus
                }}
                value={userData.height.in}
                onChange={e => handleHeightChange(e, 'in')}
                fullWidth
              />
            </Box>
          ) : (
            <TextField
              label="cm"
              variant="standard"
              type="number"
              fullWidth
              sx={measurementLabelStyle}
              InputLabelProps={{shrink: false}}
              value={userData.height.cm}
              onChange={e => handleHeightChange(e, 'cm')}
            />
          )}
        </Box>

        {/* Weight Section */}
        <Box>
          <Stack display="flex" flexDirection="row" justifyContent="space-between" alignItems="center">
            <Typography variant="h6" sx={{mb: 1, fontSize: '17px', fontWeight: '500'}}>
              Weight
            </Typography>
            <ToggleButtonGroup
              value={userData.weightUnit}
              exclusive
              onChange={(event, newUnit) => handleUnitChange(event, newUnit, 'weight')}
              sx={{mb: 2}}
            >
              <ToggleButton value="lbs" sx={toggleButtonStyles}>
                lbs
              </ToggleButton>
              <ToggleButton value="kg" sx={toggleButtonStyles}>
                kg
              </ToggleButton>
            </ToggleButtonGroup>
          </Stack>
          <TextField
            label={userData.weightUnit === 'lbs' ? 'lbs' : 'kg'}
            variant="standard"
            type="number"
            fullWidth
            sx={measurementLabelStyle}
            InputLabelProps={{
              shrink: false, // Prevent the label from shrinking on focus
            }}
            value={userData.weight}
            onChange={handleWeightChange}
          />
        </Box>
        {
          <CommonErrorMessage
            text={
              (!validation.isHeightValidated.isTrue && validation.isHeightValidated.errorMsg) ||
              (!validation.isWeightValidated.isTrue && validation.isWeightValidated.errorMsg) ||
              (!validation.isBMIValidated.isTrue && validation.isBMIValidated.errorMsg)
            }
          />
        }
      </Box>
      <Box display="flex" alignItems="center" justifyContent="center" marginTop={{xs: '18px', sm: '24px', lg: '50px'}}>
        <NextButtonDefault onClick={() => handleNextStep('heightWeight')} />
      </Box>
    </StepContainer>
  );

  //This will not render if male is slected
  const renderStep4 = () => (
    <StepContainer title="Are you pregnant or breastfeeding?">
      {[
        {label: 'Yes, I am pregnant.', value: true, id: 1},
        {label: 'Yes, I am breastfeeding.', value: false, id: 2},
        {label: 'No, I am not pregnant.', value: false, id: 3},
      ].map((option, index) => (
        <UserDemographicOptionButton
          selctedValue={userData.isPregnantId}
          value={option.id}
          key={index}
          option={option.label}
          onClick={() => handleOptionSelect('isPregnantId', option.id)}
        />
      ))}
    </StepContainer>
  );

  const renderStep5 = () => {
    // Only render if user is female and not pregnant
    if (userData.gender !== 2 || userData.isPregnantId === 1 || userData.isPregnantId === 2) {
      return null;
    }

    return (
      <StepContainer title="What best describes your current menopausal status?">
        <Stack marginTop="10px">
          {menopauseList.map((option, index) => (
            <MenopauseOptionButton
              key={index}
              option={option.name}
              onClick={() => handleOptionSelect('menopauseStatus', option.name)}
              selctedValue={userData.menopauseStatus}
              value={option.name}
            />
          ))}
        </Stack>
      </StepContainer>
    );
  };

  const renderStep6 = () => (
    <StepContainer title="Do you smoke?" sx={{marginTop: '100px'}}>
      {
        <Stack width="100%">
          {[
            {label: 'Yes', value: true},
            {label: 'No', value: false},
          ].map((option, index) => (
            <UserDemographicOptionButton
              selctedValue={userData.isSmoker}
              value={option.value}
              key={index}
              option={option.label}
              onClick={() => handleOptionSelect('isSmoker', option.value)}
            />
          ))}
        </Stack>
      }
    </StepContainer>
  );

  const renderStep7 = () => (
    <StepContainer title="Are you diabetic?" sx={{marginTop: '150px'}}>
      {[
        {label: 'Type 1', value: 1},
        {label: 'Type 2', value: 2},
        {label: 'No', value: 3},
      ].map((option, index) => (
        <UserDemographicOptionButton
          selctedValue={userData.diabetes}
          value={option.value}
          key={index}
          option={option.label}
          onClick={() => handleOptionSelect('diabetes', option.value)}
        />
      ))}
    </StepContainer>
  );

  const renderStep8 = () => (
    <StepContainer
      title="What is your ethnicity?"
      //  stepContainerSx={{ marginTop: "20px" }}
    >
      <Box>
        {ethnicitiesList.map((option, index) => (
          <UserDemographicOptionButton
            selctedValue={userData.ethnicity}
            value={option.id}
            optionBtnSx={{
              height: {
                xs: '30px',
                sm: '40px',
                md: '48px',
                lg: '48px',
              },
              width: {
                xs: '320px',
                md: '400px',
                lg: '450px',
              },
              padding: '0px',
            }}
            optionSx={{fontSize: isLaptop ? '16px' : '14px'}}
            key={index}
            option={option.name}
            onClick={() => handleOptionSelect('ethnicity', option.id)}
          />
        ))}
      </Box>
    </StepContainer>
  );

  const renderStep9 = () => (
    <StepContainer
      title="Do you have high blood pressure?"
      //  stepContainerSx={{ marginTop: {xs :"90px" , lg : "150px"}}}
    >
      {[
        {label: 'Yes', value: true},
        {label: 'No', value: false},
      ].map((option, index) => (
        <UserDemographicOptionButton
          selctedValue={userData.isHighBP}
          value={option.value}
          key={index}
          option={option.label}
          onClick={() => handleOptionSelect('isHighBP', option.value)}
        />
      ))}
    </StepContainer>
  );

  // having high bp med ?
  const renderStep10 = () => (
    <StepContainer title="Are you taking high blood pressure medication?" sx={{marginTop: '150px'}}>
      <Stack display="flex" alignItems="center" justifyContent="center" width="100%">
        {[
          {label: 'Yes', value: true},
          {label: 'No', value: false},
        ].map((option, index) => (
          <UserDemographicOptionButton
            selctedValue={userData.bpMeds}
            value={option.value}
            key={index}
            option={option.label}
            onClick={() => handleOptionSelect('bpMeds', option.value)}
          />
        ))}
      </Stack>
    </StepContainer>
  );

  // have hear attack before ?
  const renderStep11 = () => (
    <StepContainer title="Have you had a heart attack before?" sx={{marginTop: '150px'}}>
      <Stack display="flex" alignItems="center" justifyContent="center" width="100%">
        {[
          {label: 'Yes', value: true},
          {label: 'No', value: false},
        ].map((option, index) => (
          <UserDemographicOptionButton
            selctedValue={userData.hasHadHeartAttack}
            value={option.value}
            key={index}
            option={option.label}
            onClick={() => handleOptionSelect('hasHadHeartAttack', option.value)}
          />
        ))}
      </Stack>
    </StepContainer>
  );

  //had stroke before
  const renderStep12 = () => (
    <StepContainer title="Have you had a stroke before?" sx={{marginTop: '150px'}}>
      {[
        {label: 'Yes', value: true},
        {label: 'No', value: false},
      ].map((option, index) => (
        <UserDemographicOptionButton
          selctedValue={userData.hasHadStroke}
          value={option.value}
          key={index}
          option={option.label}
          onClick={() => handleOptionSelect('hasHadStroke', option.value)}
        />
      ))}
    </StepContainer>
  );

  const renderStep13 = () => (
    <StepContainer
      title="What are your wellness goals? "
      btnTitle="Next"
      skipBtnTitle="No, skip"
      isWellnessScreen="true"
      onClickNext={() => handleNextStep('wellnessGoal')}
      onClickSkip={() => handleSkip('wellnessGoal')}
    >
      {[
        {label: 'More physical energy and mental clarity', value: 'more physical energy and mental clarity'},
        {label: 'Better moods and less stress', value: 'better moods and less stress'},
        {label: 'Improve my daily digestion and gut health', value: 'improve my daily digestion and gut health'},
        {
          label: 'Build a stronger immune system for less sick days',
          value: 'build a stronger immune system for less sick days',
        },
        {
          label: 'Feel calmer before bed and get more restful sleep',
          value: 'feel calmer before bed and get more restful sleep',
        },
        {label: 'Give me foundational nutrition', value: 'give me foundational nutrition'},
      ].map((option, index) => (
        <UserDemographicOptionButton
          isWellnessScreen="true"
          onClick={() => handleOptionToggle(option.value)}
          isMultipleSelect={userData?.wellnessGoal?.includes(option.value)}
          selctedValue={userData.wellnessGoal}
          value={option.value}
          key={index}
          option={option.label}
          optionBtnSx={{
            height: {lg: '44px', md: '40px', sm: '36px', xs: '36px'},
            marginBottom: {lg: '12px', md: '12px', sm: '10px', xs: '10px'},
          }}
          optionSx={{
            lineHeight: {xs: '13px', sm: '16px', md: '18px', lg: '22.5px'},
            fontSize: {lg: '15px', md: '15px', sm: '12px', xs: '12px'},
          }}
        />
      ))}
    </StepContainer>
  );

  const renderStep14 = () => (
    <CustomFildForDetailQuestionForUserFLow
      inputValue={inputValue}
      filteredOptions={filteredOptions}
      handleSuggestedOptionSelect={(field, options) =>
        handleSuggestedOptionSelect(field, options, medicalConditionsData)
      } //pass third param as list of suggested item for field
      title="Do you have any medical conditions? "
      minRows={1}
      answerArray={userData.medicalCondition}
      placeholder="Enter medical condition name"
      value={inputValue}
      onChange={e => CustomFildForDetailQuestionInputChange(e, 'medicalCondition', medicalConditionsData)} //pass second param as list of suggested item for field
      onKeyDown={e => CustomFieldForDetailQuestionKeyPress(e, 'medicalCondition')}
      isAddButtonInUI="true"
      onAddBtnClick={e => onAddBtnClick(e, 'medicalCondition')}
      onClickNext={() => handleNextStepInCustomFiledComponent('medicalCondition')}
      onClickSkip={() => handleSkip('medicalCondition')}
      field="medicalCondition"
      onCloseIconClickInOptionArrayList={onCloseIconClickInOptionArrayList}
      btnTitle="Next"
      skipBtnTitle="No, skip"
      isFieldError={formError?.medicalCondition && formError?.medicalCondition}
    />
  );

  const renderStep15 = () => (
    <CustomFildForDetailQuestionForUserFLow
      title="Do you have any allergies? "
      inputValue={inputValue}
      filteredOptions={filteredOptions}
      handleSuggestedOptionSelect={(field, options) => handleSuggestedOptionSelect(field, options, allergenData)} //pass third param as list of suggested item for field
      onChange={e => CustomFildForDetailQuestionInputChange(e, 'allergies', allergenData)} //pass second param as list of suggested item for field
      minRows={1}
      answerArray={userData.allergies}
      placeholder="Enter allergy name"
      value={inputValue}
      onKeyDown={e => CustomFieldForDetailQuestionKeyPress(e, 'allergies')}
      isAddButtonInUI="true"
      onAddBtnClick={e => onAddBtnClick(e, 'allergies')}
      field="allergies"
      onCloseIconClickInOptionArrayList={onCloseIconClickInOptionArrayList}
      onClickNext={() => handleNextStepInCustomFiledComponent('allergies')}
      onClickSkip={() => {
        handleSkip('allergies');
      }}
      btnTitle="Next"
      skipBtnTitle="No,skip"
      isFieldError={formError?.allergies && formError?.allergies}
    />
  );

  const renderStep16 = () => (
    <StepContainer title="Are you currently taking any supplements?">
      {[
        {label: 'Yes', value: true},
        {label: 'No', value: false},
      ].map((option, index) => (
        <UserDemographicOptionButton
          key={index}
          selctedValue={userData.isTakingSupplements}
          value={option.value} // Pass value to compare with userData
          option={option.label}
          onClick={() => handleOptionSelect('isTakingSupplements', option.value)}
        />
      ))}
    </StepContainer>
  );

  const renderStep17 = () => (
    <CustomFildForDetailQuestionForUserFLow
      extraText="Please search and list the supplements you are currently using."
      inputValue={inputValue}
      filteredOptions={filteredOptions}
      handleSuggestedOptionSelect={(field, options) => handleSuggestedOptionSelect(field, options, drugData)} //pass third param as list of suggested item for field
      onChange={e => CustomFildForDetailQuestionInputChange(e, 'supplements', drugData)} //pass second param as list of suggested item for field
      title="Can you tell us more? "
      minRows={1}
      answerArray={userData.supplements}
      placeholder="Enter supplement name"
      value={inputValue}
      onKeyDown={e => CustomFieldForDetailQuestionKeyPress(e, 'supplements')}
      isAddButtonInUI="true"
      onAddBtnClick={e => onAddBtnClick(e, 'supplements')}
      field="supplements"
      onCloseIconClickInOptionArrayList={onCloseIconClickInOptionArrayList}
      onClickNext={() => handleNextStepInCustomFiledComponent('supplements')}
      btnTitle="Next"
      isFieldError={formError?.supplements && formError?.supplements}
    />
  );

  const onErrorPopUpCloseHandler = () => {
    if (isTermsChecked.termsNotAgreedError) {
      setIsTermChecked(prevState => ({
        ...prevState,
        termsNotAgreedError: false,
      }));
    } else {
      setIsServerError(false);
    }
  };

  return (
    <>
      {isLoading ? (
        <AnimationLoadingScreen />
      ) : (
        <>
          <AimdFlowQuestionBase
            IsShowBackIcon={currentStep === 1 ? false : IsShowBackIcon}
            isShowMenuIcon={isShowMenuIcon}
            backButtonHandler={backButtonHandler}
            aimdLinearBarValue={currentStep * (100 / 16)}
          >
            <Stack
              sx={{
                padding: '6px 0px',
              }}
            >
              {renderStep()}
            </Stack>
          </AimdFlowQuestionBase>
          {
            <Snackbar
              open={isServerError || isTermsChecked.termsNotAgreedError}
              autoHideDuration={3000}
              onClose={onErrorPopUpCloseHandler}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'center',
              }}
            >
              <Alert
                variant="filled"
                severity="error"
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  textAlign: 'center',
                  mb: 8,
                  fontSize: {
                    xs: 16,
                    sm: 18,
                  },
                  px: {
                    xs: 2,
                    sm: 5,
                  },
                  borderRadius: 3,
                }}
              >
                {isTermsChecked.termsNotAgreedError
                  ? ' You must check both boxes to continue.'
                  : 'An error occurred. Please try again later.'}
              </Alert>
            </Snackbar>
          }
          {/* Confirmation dialog box when user clicks Cancel button on footer */}
          <ConfirmationDialog confirmDialog={confirmDialog} setConfirmDialog={setConfirmDialog} />
          {/* Modal box when user clicks terms of use link */}
          <Dialog
            open={openModalTerms}
            maxWidth="sm"
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
              timeout: 500,
            }}
            PaperProps={{
              sx: {
                borderRadius: '30px',
                position: 'absolute',
                mx: {
                  xs: 2,
                  md: 'auto',
                },
              },
            }}
            sx={{
              top: theme.spacing(5),
              paddingY: theme.spacing(2),
              '& .MuiDialog-paperScrollPaper': {
                borderRadius: 5,
              },
            }}
          >
            <DialogTitle sx={{paddingY: theme.spacing(3)}}>
              <Typography component="span" variant="h6">
                TERMS OF SERVICE AGREEMENT
              </Typography>
            </DialogTitle>
            <DialogContent
              sx={{
                paddingY: theme.spacing(5),
                paddingRight: theme.spacing(3),
              }}
            >
              <TermsOfServiceContent />
            </DialogContent>
            <DialogActions sx={{paddingBottom: theme.spacing(2)}}>
              <Button variant="text" onClick={() => closeTermsModal(false)}>
                Close
              </Button>
            </DialogActions>
          </Dialog>
          {/* Modal box when user clicks privacy policy link */}
          <Dialog
            open={openModalPrivacy}
            maxWidth="sm"
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
              timeout: 500,
            }}
            PaperProps={{
              sx: {
                borderRadius: '30px',
                position: 'absolute',
                mx: {
                  xs: 2,
                  md: 'auto',
                },
              },
            }}
            sx={{
              top: theme.spacing(5),
              paddingY: theme.spacing(2),
              '& .MuiDialog-paperScrollPaper': {
                borderRadius: 5,
              },
            }}
          >
            <DialogTitle sx={{paddingY: theme.spacing(3)}}>
              <Typography component="span" variant="h6">
                PRIVACY POLICY
              </Typography>
            </DialogTitle>
            <DialogContent
              sx={{
                paddingY: theme.spacing(5),
                paddingRight: theme.spacing(3),
              }}
            >
              <PrivacyContent isPage={false} />
            </DialogContent>
            <DialogActions sx={{paddingBottom: theme.spacing(2)}}>
              <Button variant="text" onClick={() => closePrivacyPolicyModal(false)}>
                Close
              </Button>
            </DialogActions>
          </Dialog>
        </>
      )}
    </>
  );
};

//page UI with title & children
const StepContainer = ({
  title,
  children,
  stepContainerSx,
  subTitle = '',
  btnTitle,
  onClickNext,
  onClickSkip,
  skipBtnTitle,
  btnsx,
  childrenSx,
  isWellnessScreen = false,
}) => {
  const isLaptop = useMediaQuery(theme => theme.breakpoints.up('lg'));
  const isSmallHeight = useMediaQuery('(max-height:700px)');
  return (
    <Box
      sx={{
        // marginTop: "20px",
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        overflowY: 'scroll',
        height: 'auto',

        ...stepContainerSx, // accept extra css
      }}
    >
      <Typography
        sx={{
          mb: {
            xs: isWellnessScreen ? '6px' : '20px',
            sm: '24px',
            md: '30px',
            lg: '30px',
          },
          mt: 1,
          fontSize: isLaptop ? '25px' : '20px',
          textAlign: 'center',
          color: '#000',
          fontFamily: 'Poppins',
          fontWeight: '700',
        }}
      >
        {title}
      </Typography>

      <Stack>{children}</Stack>
      {(btnTitle || skipBtnTitle) && (
        <Stack
          sx={{
            maxWidth: '321px',
            width: '100%',
            alignItems: 'center',
            mt: {xs: isSmallHeight ? '30px' : '70px', sm: '50px', lg: isWellnessScreen ? '20px' : '50px', md: '50px'},
            ...btnsx,
          }}
        >
          {btnTitle && <NextButtonDefault btnText={btnTitle} onClick={onClickNext} />}
          {skipBtnTitle && (
            <Button
              onClick={onClickSkip}
              sx={{
                color: '#A1A0A0',
                fontSize: {xs: '15px', sm: '17px'},
                fontWeight: '600',
                '&:hover': {
                  backgroundColor: 'transparent',
                },
              }}
            >
              {skipBtnTitle}
            </Button>
          )}
        </Stack>
      )}
    </Box>
  );
};

//options select burron UI
const UserDemographicOptionButton = ({
  isWellnessScreen,
  option,
  onClick,
  optionSx,
  optionBtnSx,
  selctedValue,
  isMultipleSelect,
  optionSelectSingleValue,
  value,
}) => {
  const isLaptop = useMediaQuery(theme => theme.breakpoints.up('lg'));
  const isSelected = selctedValue === value; // handle selcted value css
  const isSingleOptionSelected = optionSelectSingleValue === value;

  const preSelectStyleForSlectedSinglevalue = {
    borderRadius: '10px',
    backgroundColor: 'var(--atplGreyColor)',
  };
  return (
    <Button
      sx={{
        width: {
          xs: '280px',
          sm: '300px',
          md: '400px',
          lg: '450px',
        },

        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background:
          isSelected || isMultipleSelect
            ? 'linear-gradient(92deg, #72D8DA 2.79%, #35C6C9 90.54%)'
            : 'rgba(114, 216, 218, 0.15)',
        color: isSelected || isMultipleSelect ? 'white !important' : '#35C6C9',
        borderRadius: '40px',
        marginBottom: '10px',
        height: {
          xs: '50px',
          sm: '50px',
          md: '60px',
          lg: '60px',
        },
        transition: 'all 0.3s ease',
        ...(isSingleOptionSelected ? preSelectStyleForSlectedSinglevalue : {}),
        '&:hover': {
          background:
            isSelected || isMultipleSelect
              ? 'linear-gradient(92deg, #72D8DA 2.79%, #35C6C9 90.54%)'
              : 'rgba(114, 216, 218, 0.15)',
          color: isSelected || isMultipleSelect ? 'white !important' : '#35C6C9',
          borderRadius: '40px',
          boxShadow: '0px 8px 19px 0px rgba(0, 0, 0, 0.10)',
        },
        ...optionBtnSx,
      }}
      onClick={onClick}
    >
      <Typography
        sx={{
          width: '100%',
          fontSize: {lg: '20px', md: '18px', sm: '16px', xs: '16px'},
          fontWeight: 600,
          lineHeight: '22.5px',
          textAlign: 'center',
          ...optionSx,
        }}
      >
        {option}
      </Typography>
    </Button>
  );
};

// Specialized button for menopause options with improved UI
const MenopauseOptionButton = ({option, onClick, selctedValue, value}) => {
  const isLaptop = useMediaQuery(theme => theme.breakpoints.up('lg'));
  const isSelected = selctedValue === value;

  // Parse the option text to separate main text from description
  const parseOptionText = text => {
    const match = text.match(/^(.+?)\s*\((.+)\)$/);
    if (match) {
      return {
        mainText: match[1].trim(),
        description: match[2].trim(),
      };
    }
    return {
      mainText: text,
      description: null,
    };
  };

  const {mainText, description} = parseOptionText(option);

  return (
    <Button
      sx={{
        width: {
          xs: '280px',
          md: '400px',
          lg: '430px',
        },
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        background: isSelected ? 'linear-gradient(92deg, #72D8DA 2.79%, #35C6C9 90.54%)' : 'rgba(114, 216, 218, 0.15)',
        color: isSelected ? 'white !important' : '#35C6C9',
        borderRadius: '40px',
        marginBottom: '12px',
        height: {
          xs: '70px',
          sm: '75px',
          md: '80px',
          lg: '85px',
        },
        padding: '16px 20px',
        transition: 'all 0.3s ease',
        '&:hover': {
          background: isSelected
            ? 'linear-gradient(92deg, #72D8DA 2.79%, #35C6C9 90.54%)'
            : 'rgba(114, 216, 218, 0.25)',
          color: isSelected ? 'white !important' : '#35C6C9',
          borderRadius: '40px',
          boxShadow: '0px 8px 19px 0px rgba(0, 0, 0, 0.10)',
        },
      }}
      onClick={onClick}
    >
      {/* Main heading - bold and centered */}
      <Typography
        sx={{
          width: '100%',
          fontSize: {xs: '13px', sm: '14px', md: '15px', lg: '16px'},
          fontWeight: 700,
          lineHeight: {xs: '18px', sm: '20px', md: '22px', lg: '24px'},
          textAlign: 'center',
          marginBottom: description ? '4px' : '0px',
        }}
      >
        {mainText}
      </Typography>

      {/* Description - lighter weight, smaller font */}
      {description && (
        <Typography
          sx={{
            width: '100%',
            fontSize: {xs: '10px', sm: '11px', md: '12px', lg: '13px'},
            fontWeight: 400,
            lineHeight: {xs: '14px', sm: '16px', md: '18px', lg: '20px'},
            textAlign: 'center',
            opacity: 0.9,
          }}
        >
          {description}
        </Typography>
      )}
    </Button>
  );
};

//Next button resusanle for this page
const NextButtonDefault = ({btnText, onClick, isWellnessScreen = false}) => {
  const isLaptop = useMediaQuery(theme => theme.breakpoints.up('lg'));

  return (
    <Button
      sx={{
        maxWidth: '321px',
        minWidth: '100%',
        minHeight: {
          xs: '20px',
          sm: '50px',
          md: '65px',
          lg: '65px',
        },
        // minHeight : "30px",
        padding: {
          xs: isWellnessScreen ? '2px 5px' : '8px 5px',
          sm: '12px 14px',
          md: '12px 14px',
          lg: '12px 12px',
        },
        background: 'linear-gradient(92deg, #72d8da 2.79%, #35c6c9 90.54%)',
        boxShadow: '0px 4px 5px 0px rgba(0, 0, 0, 0.09),0px 5px 11px 0px rgba(0, 0, 0, 0.10)',
        borderRadius: '40px',
        color: '#fff',
        textAlign: 'center',
        fontSize: {
          xs: '16px',
          lg: '20px',
        },
        border: '3px solid transparent !important',
        fontWeight: 600,
        '&:hover': {
          color: '#69D6D8',
          background: 'white',
          border: '3px solid #72d8da !important',
          borderRadius: '40px',
        },
      }}
      onClick={onClick}
    >
      {btnText ? btnText : 'Next'}
    </Button>
  );
};

// Enhanced CustomTextFieldForUserFlow component
const CustomTextFieldForUserFlow = ({
  placeholder,
  minRows = 1,
  value,
  onChange,
  onKeyDown,
  sx = {},
  onAddBtnClick,
  isAddButtonInUI = 'false',
}) => {
  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        my: '10px',
      }}
    >
      <TextField
        fullWidth
        minRows={minRows}
        value={value}
        onChange={onChange}
        onKeyDown={onKeyDown}
        placeholder={placeholder}
        sx={{
          width: {
            xs: '300px',
            sm: '360px',
            md: '400px',
          },
          mt: {xs: 1, md: '10px', lg: '14px'},
          borderRadius: '40px',
          border: '1px solid #72D8DA',
          '& .MuiOutlinedInput-root': {
            transition: 'all 0.2s ease-in-out',
            '& fieldset': {
              border: '1px solid #72D8DA', // remove default border from txtfield
              borderRadius: '40px',
            },

            '&.Mui-focused': {
              '& fieldset': {
                border: '1px solid #72D8DA',
                borderRadius: '40px',
              },
            },
            '&:hover': {
              '& fieldset': {
                border: '1px solid #00B8B8', // Hover border color
              },
            },
          },
          '& .MuiInputBase-input': {
            fontSize: {
              xs: '16px',
              sm: '19px',
            },
            lineHeight: '28.5px',
            fontWeight: 500,
            padding: '16px 14px',
          },
          '& ::placeholder': {
            color: '#35C6C9 !important',
            opacity: 1,
            fontSize: {
              xs: '14px',
              sm: '16px',
              lg: '16px',
            },
            fontWeight: 500,
          },
          ...sx,
        }}
        InputProps={{
          endAdornment: isAddButtonInUI === 'true' && (
            <InputAdornment
              position="end"
              sx={{
                marginLeft: 0,
                paddingLeft: 0,
              }}
            >
              <Box
                onClick={onAddBtnClick}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  padding: '4px 2px',
                  cursor: 'pointer',
                }}
              >
                <Typography
                  sx={{
                    fontSize: {xs: '14px', sm: '16px', md: '18px', lg: '18px'},
                    fontWeight: 500,
                    color: 'grey',
                  }}
                >
                  Add +
                </Typography>
              </Box>
            </InputAdornment>
          ),
        }}
      />
    </Box>
  );
};

const CustomFildForDetailQuestionForUserFLow = ({
  filteredOptions,
  inputValue,
  handleSuggestedOptionSelect,
  title,
  placeholder,
  minRowsCount = 1,
  answerArray,
  onChange,
  value,
  onKeyDown,
  extraText,
  supplemtNameCss,
  btnTitle,
  onClickNext,
  onClickSkip,
  skipBtnTitle,
  onAddBtnClick,
  isAddButtonInUI,
  onCloseIconClickInOptionArrayList,
  field,
  isFieldError,
}) => {
  const isSmallHeight = useMediaQuery('(max-height:700px)');
  return (
    <StepContainer
      title={title}
      subTitle={extraText}
      btnTitle={btnTitle}
      onClickNext={onClickNext}
      onClickSkip={onClickSkip}
      skipBtnTitle={skipBtnTitle}
    >
      {extraText && (
        <Typography
          color="#000"
          sx={{
            fontSize: '14px',
            fontWeight: '400',
            lineHeight: '18px',
            textAlign: 'center',
          }}
        >
          {extraText}
        </Typography>
      )}
      <CustomTextFieldForUserFlow
        isAddButtonInUI={isAddButtonInUI}
        minRows={minRowsCount}
        value={value}
        onChange={onChange}
        onKeyDown={onKeyDown}
        placeholder={placeholder}
        onAddBtnClick={onAddBtnClick}
      />
      {isFieldError && (
        <CommonErrorMessage
          text={isFieldError}
          sx={{
            width: {
              xs: '300px',
              sm: '360px',
              md: '400px',
            },
          }}
        />
      )}
      {/* suggested list */}
      {filteredOptions?.length > 0 && inputValue && (
        <Stack
          sx={{
            height: '200px',
            overflowY: 'scroll',
            border: '1px solid #ccc',
            borderRadius: '8px',
            padding: '8px',
            backgroundColor: '#fff',
            position: 'absolute',
            marginTop: '100px',
            zIndex: '200',
          }}
        >
          {filteredOptions.map((option, index) => (
            <Box
              key={index}
              sx={{
                padding: '8px 4px',
                cursor: 'pointer',
                width: {
                  xs: '300px',
                  sm: '360px',
                  md: '400px',
                },
                boxSizing: 'border-box',
                '&:hover': {background: `linear-gradient(92deg, #72D8DA 2.79%, #35C6C9 90.54%)`, color: 'white'},
              }}
              onClick={() => handleSuggestedOptionSelect(field, option)}
            >
              <Typography fontWeight="500" fontSize="14px" lineHeight="18px">
                {option}
              </Typography>
            </Box>
          ))}
        </Stack>
      )}
      {/* lsit of user added medicalCondition, allergy, supplemets  */}
      <Stack
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'start',
          alignItems: 'start',
          padding: '0px 8px',
          boxSizing: 'border-box',
          flexWrap: 'wrap',
          marginTop: '20px',
          maxHeight: {lg: '180px', md: '120px', xs: isSmallHeight ? '100px' : '200px'},
          overflowY: 'scroll',
          width: {
            xs: '100%',
            sm: '360px',
            md: '400px',
          },
        }}
      >
        {answerArray?.length > 0 &&
          answerArray.map((option, index) => (
            <Box
              key={index}
              sx={{
                borderRadius: '30px',
                background: `linear-gradient(92deg, #72D8DA 2.79%, #35C6C9 90.54%)`,
                color: '#fff',
                display: 'flex',
                justifyContent: 'space-between',
                marginRight: '10px',
                marginBottom: '10px',
                minHeight: '36px',
                boxSizing: 'border-box',
                padding: '14px 20px',
                minWidth: '105px',
                alignItems: 'center',
              }}
            >
              <Typography sx={{wordBreak: 'break-word', fontWeight: '500', fontSize: '12px', lineHeight: '18px'}}>
                {option}
              </Typography>
              <Box
                // On clicking the close icon next to an item in the list, it will remove that item from the array of the specified field.
                onClick={() => onCloseIconClickInOptionArrayList(option, field)}
                sx={{
                  padding: '0px 4px 0px 10px',
                  cursor: 'pointer',
                }}
              >
                <CloseIcon fontSize="10px" />
              </Box>
            </Box>
          ))}
      </Stack>
    </StepContainer>
  );
};

export default AimdFlowQuestionsScreen;
